import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcleanup0postPostManualPacksIdCleanupPreviewResponseSchema = jsonObject
export type tcpcleanup0postPostManualPacksIdCleanupPreviewResponse = z.infer<typeof tcpcleanup0postPostManualPacksIdCleanupPreviewResponseSchema>
export const tcpcleanup0postPostManualPacksIdCleanupApplyResponseSchema = jsonObject
export type tcpcleanup0postPostManualPacksIdCleanupApplyResponse = z.infer<typeof tcpcleanup0postPostManualPacksIdCleanupApplyResponseSchema>
